import localeJa from '@angular/common/locales/ja';
import { Component, Inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { MemoizedSelector, Store } from '@ngrx/store';
import { getSpinnerStatus } from '@core/store/features/spinner/spinner.selector';
import { ResourcePolicyService } from '@core/services/apis';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  isShow$ = this.store.select(getSpinnerStatus as MemoizedSelector<object, boolean>);

  title = 'caremoni-console';
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private store: Store,
    private resourcePolicyService: ResourcePolicyService
  ) {

    this.resourcePolicyService.checkResourcePolicy().subscribe();

    // CUSTOM_ICON
    this.matIconRegistry.addSvgIconResolver((name, namespace) => {
      const iconPath = './assets/icons' + (namespace ? '/' + namespace : '') + '/' + name + '.svg';
      return this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath);
    });

    registerLocaleData(localeJa, 'ja-JP');

  }
}
